import { WSFilter } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { usePayerEngagementFilterOptions } from "../../../../Payers/hooks/usePayerEngagementFilterOptions";

export function useBuildConfig() {
  const assignmentOptions = usePayerEngagementFilterOptions({
    filter: {
      "engagements.isWorkLoggingEnabled": true
    }
  });

  return useMemo(
    (): WSFilter[] => [
      {
        title: "Assignment",
        name: "assignmentId",
        type: "select",
        apiOptions: assignmentOptions
      }
    ],
    [assignmentOptions]
  );
}
